import React, { useState, useEffect } from "react";
//import "./styles.css";
import { Row, Col, Form, Button } from "react-bootstrap";
// import LeftpanelMember from "../../../components/leftpanel/left-panel-admin";
// import HeaderPart from "../../../components/layout/header-admin/header";
import "./addcertificate.css";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { CertDet2, Policies } from "../../../assets/images";
import axios from "../../../axios/axios";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { message } from "antd";
import LoadingOverlay from "react-loading-overlay";
import { adminConfig } from "../../../utils/adminConfig";
import { useHistory } from "react-router-dom";
const CertificateAdd = () => {
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [certis, setCertis] = useState([]);

  const [certi, setCerti] = useState({
    isNew: false,
    certificateId: "",
    certificateTitle: "",
    certificatePrice: "",
    certificateImg: "",
    certificateLogo: "",
    certificateTerms: "",
    certificatePaymentUrl: "",
    redirectionUrl: "",
    isHasWhiteLevel: false,
    whiteLevelData: {
      certificateTitle: "",
      certificateImgWhiteLevel: "",
      certificateLogoWhiteLevel: "",
      certificateTermsWhiteLevel: "",
      haveAnyMailTemplateId: true,
      mailTemplateIdForSentCertificate: "",
      mailTemplateIdForRedeemCertificate: "",
      reddemDescription: "",
      certificateDesc: "",
      certificateFinePrint: "",
      shortDescription: "",
    },
    haveAnyMailTemplateId: true,
    mailTemplateIdForSentCertificate: "",
    mailTemplateIdForRedeemCertificate: "",
    reddemDescription: "",
    certificateDesc: "",
    certificateFinePrint: "",
    shortDescription: "",
  });

  const handleCertiChange = (e) => {
    const { name, value, type, checked, files } = e.target;
    let val = value;
    if (type === 'checkbox') val = checked;
    else if (type === 'file') val = files[0];
    else if (value === 'true') val = true;
    else if (value === 'false') val = false;

    setCerti({ ...certi, [name]: val });
  };

  const handleWhiteLevelChange = (e) => {
    const { name, value, type, checked, files } = e.target;
    let val = value;
    if (type === 'checkbox') val = checked;
    else if (type === 'file') val = files[0];
    else if (value === 'true') val = true;
    else if (value === 'false') val = false;

    setCerti({
      ...certi,
      whiteLevelData: {
        ...certi.whiteLevelData,
        [name]: val
      }
    });
  };

  const renderFilePreview = (file, isPdf) => {
    if (!file) return null;
    if (typeof file === 'string') {
      return isPdf ? (
        <div className="mt-2"><a href={file} target="_blank" rel="noreferrer">View Current PDF</a></div>
      ) : (
        <div className="mt-2"><img src={file} alt="preview" style={{ maxWidth: "100px", maxHeight: "100px" }} /></div>
      );
    }
    return isPdf ? (
      <div className="mt-2 text-success">New PDF selected: {file.name}</div>
    ) : (
      <div className="mt-2"><img src={URL.createObjectURL(file)} alt="preview" style={{ maxWidth: "100px", maxHeight: "100px" }} /></div>
    );
  };

  const addCertiCode = async (e) => {
    e.preventDefault();
    setLoading(true);

    if (certi.isNew && !certi.certificateId) {
      message.error("Please enter a Certificate ID");
      setLoading(false);
      return;
    }

    if (certi.isHasWhiteLevel) {
      const {
        certificateTitle, certificateImgWhiteLevel, certificateLogoWhiteLevel, certificateTermsWhiteLevel,
        haveAnyMailTemplateId, mailTemplateIdForSentCertificate,
        mailTemplateIdForRedeemCertificate, reddemDescription,
        certificateDesc, certificateFinePrint, shortDescription
      } = certi.whiteLevelData;

      if (!certificateTitle || !certificateImgWhiteLevel || !certificateLogoWhiteLevel || !certificateTermsWhiteLevel) {
        let missing = [];
        if (!certificateTitle) missing.push("Title");
        if (!certificateImgWhiteLevel) missing.push("Image");
        if (!certificateLogoWhiteLevel) missing.push("Banner");
        if (!certificateTermsWhiteLevel) missing.push("Terms");
        message.error(`Please fill missing White Level fields: ${missing.join(", ")}`);
        setLoading(false);
        return;
      }

      if (haveAnyMailTemplateId) {
        if (!mailTemplateIdForSentCertificate || !mailTemplateIdForRedeemCertificate) {
          message.error("Please provide both Mail Template IDs for White Level");
          setLoading(false);
          return;
        }
      } else {
        if (!reddemDescription || !certificateDesc || !certificateFinePrint || !shortDescription) {
          message.error("Please provide all description fields for White Level");
          setLoading(false);
          return;
        }
      }
    } else {
      const {
        certificateTitle, certificatePrice, certificateImg, certificateLogo,
        certificatePaymentUrl, redirectionUrl, certificateTerms,
        haveAnyMailTemplateId, mailTemplateIdForSentCertificate,
        mailTemplateIdForRedeemCertificate, reddemDescription,
        certificateDesc, certificateFinePrint, shortDescription
      } = certi;

      if (!certificateTitle || !certificatePrice || !certificateImg || !certificateLogo || !certificatePaymentUrl || !redirectionUrl || !certificateTerms) {
        let missing = [];
        if (!certificateTitle) missing.push("Title");
        if (!certificatePrice) missing.push("Price");
        if (!certificateImg) missing.push("Image");
        if (!certificateLogo) missing.push("Banner");
        if (!certificatePaymentUrl) missing.push("Payment URL");
        if (!redirectionUrl) missing.push("Redirection URL");
        if (!certificateTerms) missing.push("Terms");
        message.error(`Please fill missing Standard Data fields: ${missing.join(", ")}`);
        setLoading(false);
        return;
      }

      if (haveAnyMailTemplateId) {
        if (!mailTemplateIdForSentCertificate || !mailTemplateIdForRedeemCertificate) {
          message.error("Please provide both Mail Template IDs for Standard Data");
          setLoading(false);
          return;
        }
      } else {
        if (!reddemDescription || !certificateDesc || !certificateFinePrint || !shortDescription) {
          message.error("Please provide all description fields for Standard Data");
          setLoading(false);
          return;
        }
      }
    }

    // Prepare data
    const formData = new FormData();
    (certi._id && !certi.isNew) ? formData.append("certificateId", certi.certificateId) : formData.append("certificateId", certi.certificateId);
    formData.append("certificateIdentity", certi.certificateId);
    formData.append("isHasWhiteLevel", certi.isHasWhiteLevel);

    if (certi.isHasWhiteLevel) {
      formData.append("whiteLevelData", JSON.stringify(certi.whiteLevelData));
      // For files in whiteLevelData, we might need to append them individually if they are File objects
      // but the backend needs to handle this. Assuming the current setup requires just json or individual keys:
      // We will send the object as JSON and if there are files, we will append them separately.
      if (typeof certi.whiteLevelData.certificateImgWhiteLevel === 'object') formData.append("certificateImgWhiteLevel", certi.whiteLevelData.certificateImgWhiteLevel);
      if (typeof certi.whiteLevelData.certificateLogoWhiteLevel === 'object') formData.append("certificateLogoWhiteLevel", certi.whiteLevelData.certificateLogoWhiteLevel);
      if (typeof certi.whiteLevelData.certificateTermsWhiteLevel === 'object') formData.append("certificateTermsWhiteLevel", certi.whiteLevelData.certificateTermsWhiteLevel);
    } else {
      formData.append("certificateTitle", certi.certificateTitle);
      formData.append("certificatePrice", parseInt(certi.certificatePrice));
      formData.append("certificatePaymentUrl", certi.certificatePaymentUrl);
      formData.append("redirectionUrl", certi.redirectionUrl);
      formData.append("haveAnyMailTemplateId", certi.haveAnyMailTemplateId);

      if (certi.haveAnyMailTemplateId) {
        formData.append("mailTemplateIdForSentCertificate", certi.mailTemplateIdForSentCertificate);
        formData.append("mailTemplateIdForRedeemCertificate", certi.mailTemplateIdForRedeemCertificate);
      } else {
        formData.append("reddemDescription", certi.reddemDescription);
        formData.append("certificateDesc", certi.certificateDesc);
        formData.append("certificateFinePrint", certi.certificateFinePrint);
        formData.append("shortDescription", certi.shortDescription);
      }

      if (typeof certi.certificateImg === 'object') formData.append("certificateImg", certi.certificateImg);
      else formData.append("certificateImg", certi.certificateImg);

      if (typeof certi.certificateLogo === 'object') formData.append("certificateLogo", certi.certificateLogo);
      else formData.append("certificateLogo", certi.certificateLogo);

      if (typeof certi.certificateTerms === 'object') formData.append("certificateTerms", certi.certificateTerms);
      else formData.append("certificateTerms", certi.certificateTerms);
    }

    // To keep it simple based on the previous json body implementation, we can send json instead if files are base64, but since they are objects, we use FormData if we want to support file uploads.
    // If the API endpoint previously used JSON:
    let data = {
      certificateId: certi._id,
      certificateIdentity: certi.certificateId,
      isHasWhiteLevel: certi.isHasWhiteLevel,
      haveAnyMailTemplateId: certi.haveAnyMailTemplateId,
      mailTemplateIdForSentCertificate: certi.mailTemplateIdForSentCertificate,
      mailTemplateIdForRedeemCertificate: certi.mailTemplateIdForRedeemCertificate,
      reddemDescription: certi.reddemDescription,
      certificateDesc: certi.certificateDesc,
      certificateFinePrint: certi.certificateFinePrint,
      shortDescription: certi.shortDescription,
      whiteLevelData: certi.whiteLevelData,
      certificateTitle: certi.certificateTitle,
      certificatePrice: certi.certificatePrice,
      certificateImg: certi.certificateImg,
      certificateLogo: certi.certificateLogo,
      certificatePaymentUrl: certi.certificatePaymentUrl,
      redirectionUrl: certi.redirectionUrl,
      certificateTerms: certi.certificateTerms,
    };

    // If using FormData is required for file uploads:
    const finalData = new FormData();
    Object.keys(data).forEach(key => {
      if (key === 'whiteLevelData') {
        const wl = { ...data[key] };
        if (typeof wl.certificateImgWhiteLevel === 'object') {
          finalData.append('certificateImgWhiteLevel', wl.certificateImgWhiteLevel);
          wl.certificateImgWhiteLevel = undefined;
        }
        if (typeof wl.certificateLogoWhiteLevel === 'object') {
          finalData.append('certificateLogoWhiteLevel', wl.certificateLogoWhiteLevel);
          wl.certificateLogoWhiteLevel = undefined;
        }
        if (typeof wl.certificateTermsWhiteLevel === 'object') {
          finalData.append('certificateTermsWhiteLevel', wl.certificateTermsWhiteLevel);
          wl.certificateTermsWhiteLevel = undefined;
        }
        finalData.append(key, JSON.stringify(wl));
      } else if (typeof data[key] === 'object' && data[key] !== null) {
        finalData.append(key, data[key]);
      } else {
        if (data[key] !== undefined && data[key] !== null) {
          finalData.append(key, data[key]);
        }
      }
    });
    console.log("finalData", finalData, "data", data);
    await axios
      .post(`/add-certificates`, finalData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          ...adminConfig().headers
        }
      })
      .then((res) => {
        if (res.data.status === true) {
          getCertis();
          /// form reset
          document.getElementById("addcerti").reset();
          message.success("added certificate successfully");
          history.push('/certificates')
        } else {
          message.error("failed adding certificates");
        }
      })
      .catch((err) => {
        console.log(err);
      });
    setLoading(false);
  };

  useEffect(() => {
    getCertis();
  }, []);

  const getCertis = () => {
    setLoading(true);

    axios
      .get(`/all-admin-certificates`, adminConfig())
      .then((res) => {
        if (res.data.status === true) {
          setCertis(res.data.data);
          setLoading(false);
        } else {
          message.error("Data Not Found");
          setLoading(false);
        }
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  };

  const handleChange = (index) => {
    if (index === "new") {
      setCerti({
        isNew: true,
        certificateId: "",
        certificateTitle: "",
        certificatePrice: "",
        certificateImg: "",
        certificateLogo: "",
        certificateTerms: "",
        certificatePaymentUrl: "",
        redirectionUrl: "",
        isHasWhiteLevel: false,
        whiteLevelData: {
          certificateTitle: "",
          certificateImgWhiteLevel: "",
          certificateLogoWhiteLevel: "",
          certificateTermsWhiteLevel: "",
          haveAnyMailTemplateId: true,
          mailTemplateIdForSentCertificate: "",
          mailTemplateIdForRedeemCertificate: "",
          reddemDescription: "",
          certificateDesc: "",
          certificateFinePrint: "",
          shortDescription: "",
        },
        haveAnyMailTemplateId: true,
        mailTemplateIdForSentCertificate: "",
        mailTemplateIdForRedeemCertificate: "",
        reddemDescription: "",
        certificateDesc: "",
        certificateFinePrint: "",
        shortDescription: "",
      });
      return;
    }

    const selectedCert = certis[index];
    console.log(selectedCert?.whiteLevelData,"sss")
    setCerti({
      ...certi,
      ...selectedCert,
      isNew: false,
      whiteLevelData: {
        ...certi.whiteLevelData,
        ...selectedCert?.whiteLevelData,
        certificateImgWhiteLevel: selectedCert?.whiteLevelData?.certificateImg,
        certificateLogoWhiteLevel: selectedCert?.whiteLevelData?.certificateLogo,
        certificateTermsWhiteLevel: selectedCert?.whiteLevelData?.certificateTerms
      }
    });
  };

  return (
    // <div>
    //     <HeaderPart />
    //     <div className='main_cont'>
    //         <LeftpanelMember />
    <LoadingOverlay active={loading} spinner text="loading...">
      <div className="right_cont">
        <div className="right_banner_banner_cnt" style={{ padding: '20px' }}>
          <h2>Certificate Setup</h2>
          <Form onSubmit={addCertiCode} id="addcerti">
            <Row className="mb-3">
              <Col md={6}>
                <Form.Group>
                  <Form.Label>Select a certificate to update or create a new one</Form.Label>
                  <Form.Select
                    className="form-control"
                    onChange={(e) => handleChange(e.target.value)}
                    defaultValue=""
                  >
                    <option value="" disabled>Select a certificate</option>
                    <option value="new">Create New Certificate</option>
                    {certis.map((c, index) => (
                      <option key={index} value={index}>
                        {c.certificateId} - {c.certificateTitle || 'Unnamed'}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </Col>
            </Row>
              {console.log("certi", certi)}
            {(certi.certificateId || certi.isNew) && (
              <>
                {certi.isNew && (
                  <Row className="mb-3">
                    <Col md={6}>
                      <Form.Group>
                        <Form.Label>Certificate ID</Form.Label>
                        <Form.Control
                          type="text"
                          name="certificateId"
                          value={certi.certificateId || ''}
                          onChange={handleCertiChange}
                          required
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                )}
                <Row className="mb-3">
                  <Col md={4}>
                    <Form.Group>
                      <Form.Label>Certificate Price</Form.Label>
                      <Form.Control
                        type="text"
                        name="certificatePrice"
                        value={certi.certificatePrice || ''}
                        onChange={handleCertiChange}
                      />
                    </Form.Group>
                  </Col>
                  <Col md={4}>
                    <Form.Group>
                      <Form.Label>Certificate Payment URL</Form.Label>
                      <Form.Control
                        type="text"
                        name="certificatePaymentUrl"
                        value={certi.certificatePaymentUrl || ''}
                        onChange={handleCertiChange}
                      />
                    </Form.Group>
                  </Col>
                  <Col md={4}>
                    <Form.Group>
                      <Form.Label>Redirection URL</Form.Label>
                      <Form.Control
                        type="text"
                        name="redirectionUrl"
                        value={certi.redirectionUrl || ''}
                        onChange={handleCertiChange}
                      />
                    </Form.Group>
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col md={12}>
                    <Form.Group>
                      <Form.Label>Change Data  - for white level or without white level</Form.Label>
                      <div>
                        <Form.Check
                          inline
                          type="radio"
                          label="Without White Level Data (Default)"
                          name="isHasWhiteLevel"
                          value="false"
                          checked={certi.isHasWhiteLevel === false}
                          onChange={handleCertiChange}
                        />
                        <Form.Check
                          inline
                          type="radio"
                          label="White Level Data"
                          name="isHasWhiteLevel"
                          value="true"
                          checked={certi.isHasWhiteLevel === true}
                          onChange={handleCertiChange}
                        />
                      </div>
                      <small className="text-danger">To create a new certificate, first add and save the certificate using the default settings <strong>(without Whitelabel data)</strong>. Once it is created, you can edit it and add the <strong> Whitelabel data</strong>.</small>
                    </Form.Group>
                  </Col>
                </Row>

                {certi.isHasWhiteLevel === true && (
                  <div className="p-3 border mb-3">
                    <h5 className="mb-3">White Level Data</h5>
                    <Row className="mb-3">
                      <Col md={12}>
                        <Form.Group>
                          <Form.Label>Certificate Title</Form.Label>
                          <Form.Control
                            type="text"
                            name="certificateTitle"
                            value={certi.whiteLevelData.certificateTitle || ''}
                            onChange={handleWhiteLevelChange}
                          />
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <Col md={4}>
                        <Form.Group>
                          <Form.Label>Certificate Image</Form.Label>
                          <Form.Control
                            type="file"
                            accept="image/*"
                            name="certificateImgWhiteLevel"
                            onChange={handleWhiteLevelChange}
                          />
                          {renderFilePreview(certi.whiteLevelData.certificateImgWhiteLevel, false)}
                        </Form.Group>
                      </Col>
                      <Col md={4}>
                        <Form.Group>
                          <Form.Label>Certificate Banner</Form.Label>
                          <Form.Control
                            type="file"
                            accept="image/*"
                            name="certificateLogoWhiteLevel"
                            onChange={handleWhiteLevelChange}
                          />
                          {renderFilePreview(certi.whiteLevelData.certificateLogoWhiteLevel, false)}
                        </Form.Group>
                      </Col>
                      <Col md={4}>
                        <Form.Group>
                          <Form.Label>Certificate Terms</Form.Label>
                          <Form.Control
                            type="file"
                            accept="application/pdf"
                            name="certificateTermsWhiteLevel"
                            onChange={handleWhiteLevelChange}
                          />
                          {renderFilePreview(certi.whiteLevelData.certificateTermsWhiteLevel, true)}
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <Col md={12}>
                        <Form.Group>
                          <Form.Label>Have Any Mail Template ID?
                          <small className="text-danger"> If you have any mailchimp template id, then check this option</small></Form.Label>
                          <div>
                            <Form.Check
                              inline
                              type="radio"
                              label="Yes"
                              name="haveAnyMailTemplateId"
                              value="true"
                              checked={certi.whiteLevelData.haveAnyMailTemplateId === true}
                              onChange={handleWhiteLevelChange}
                            />
                            <Form.Check
                              inline
                              type="radio"
                              label="No"
                              name="haveAnyMailTemplateId"
                              value="false"
                              checked={certi.whiteLevelData.haveAnyMailTemplateId === false}
                              onChange={handleWhiteLevelChange}
                            />
                          </div>
                        </Form.Group>
                      </Col>
                    </Row>

                    {certi.whiteLevelData.haveAnyMailTemplateId === true ? (
                      <Row className="mb-3">
                        <Col md={6}>
                          <Form.Group>
                            <Form.Label>Mail Template ID for Sent Certificate</Form.Label>
                            <Form.Control
                              type="text"
                              placeholder="eg., TVI_DREAM_VACATION_CERTIFICATE"
                              name="mailTemplateIdForSentCertificate"
                              value={certi.whiteLevelData.mailTemplateIdForSentCertificate || ''}
                              onChange={handleWhiteLevelChange}
                            />
                          </Form.Group>
                        </Col>
                        <Col md={6}>
                          <Form.Group>
                            <Form.Label>Mail Template ID for Redeem Certificate</Form.Label>
                            <Form.Control
                              type="text"
                              placeholder="eg., TVI_DREAM_VACATION_REDEEM"
                              name="mailTemplateIdForRedeemCertificate"
                              value={certi.whiteLevelData.mailTemplateIdForRedeemCertificate || ''}
                              onChange={handleWhiteLevelChange}
                            />
                          </Form.Group>
                        </Col>
                      </Row>
                    ) : (
                      <>
                        <Row className="mb-3">
                          <Col md={6}>
                            <Form.Group>
                              <Form.Label>Redeem Description</Form.Label>
                              <CKEditor
                                editor={ClassicEditor}
                                data={certi.whiteLevelData.reddemDescription || ''}
                                onChange={(event, editor) => {
                                  handleWhiteLevelChange({ target: { name: 'reddemDescription', value: editor.getData() } });
                                }}
                              />
                            </Form.Group>
                          </Col>
                          <Col md={6}>
                            <Form.Group>
                              <Form.Label>Certificate Description</Form.Label>
                              <CKEditor
                                editor={ClassicEditor}
                                data={certi.whiteLevelData.certificateDesc || ''}
                                onChange={(event, editor) => {
                                  handleWhiteLevelChange({ target: { name: 'certificateDesc', value: editor.getData() } });
                                }}
                              />
                            </Form.Group>
                          </Col>
                        </Row>
                        <Row className="mb-3">
                          <Col md={6}>
                            <Form.Group>
                              <Form.Label>Certificate Fine Print</Form.Label>
                              <CKEditor
                                editor={ClassicEditor}
                                data={certi.whiteLevelData.certificateFinePrint || ''}
                                onChange={(event, editor) => {
                                  handleWhiteLevelChange({ target: { name: 'certificateFinePrint', value: editor.getData() } });
                                }}
                              />
                            </Form.Group>
                          </Col>
                          <Col md={6}>
                            <Form.Group>
                              <Form.Label>Short Description</Form.Label>
                              <CKEditor
                                editor={ClassicEditor}
                                data={certi.whiteLevelData.shortDescription || ''}
                                onChange={(event, editor) => {
                                  handleWhiteLevelChange({ target: { name: 'shortDescription', value: editor.getData() } });
                                }}
                              />
                            </Form.Group>
                          </Col>
                        </Row>
                      </>
                    )}
                  </div>
                )}

                {certi.isHasWhiteLevel === false && (
                  <div className="p-3 border mb-3">
                    <h5 className="mb-3">Standard Data</h5>
                    <Row className="mb-3">
                      <Col md={12}>
                        <Form.Group>
                          <Form.Label>Certificate Title</Form.Label>
                          <Form.Control
                            type="text"
                            name="certificateTitle"
                            value={certi.certificateTitle || ''}
                            onChange={handleCertiChange}
                          />
                        </Form.Group>
                      </Col>

                    </Row>
                    <Row className="mb-3">
                      <Col md={4}>
                        <Form.Group>
                          <Form.Label>Certificate Image</Form.Label>
                          <Form.Control
                            type="file"
                            accept="image/*"
                            name="certificateImg"
                            onChange={handleCertiChange}
                          />
                          {renderFilePreview(certi.certificateImg, false)}
                        </Form.Group>
                      </Col>
                      <Col md={4}>
                        <Form.Group>
                          <Form.Label>Certificate Banner</Form.Label>
                          <Form.Control
                            type="file"
                            accept="image/*"
                            name="certificateLogo"
                            onChange={handleCertiChange}
                          />
                          {renderFilePreview(certi.certificateLogo, false)}
                        </Form.Group>
                      </Col>
                      <Col md={4}>
                        <Form.Group>
                          <Form.Label>Certificate Terms</Form.Label>
                          <Form.Control
                            type="file"
                            accept="application/pdf"
                            name="certificateTerms"
                            onChange={handleCertiChange}
                          />
                          {renderFilePreview(certi.certificateTerms, true)}
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <Col md={12}>
                        <Form.Group>
                          <Form.Label>Have Any Mail Template ID? <small className="text-danger">If you have any mailchimp template id, then check this option</small></Form.Label>
                          
                          <div>
                            <Form.Check
                              inline
                              type="radio"
                              label="Yes"
                              name="haveAnyMailTemplateId"
                              value="true"
                              checked={certi.haveAnyMailTemplateId === true}
                              onChange={handleCertiChange}
                            />
                            <Form.Check
                              inline
                              type="radio"
                              label="No"
                              name="haveAnyMailTemplateId"
                              value="false"
                              checked={certi.haveAnyMailTemplateId === false}
                              onChange={handleCertiChange}
                            />
                          </div>
                        </Form.Group>
                      </Col>
                    </Row>

                    {certi.haveAnyMailTemplateId === true ? (
                      <Row className="mb-3">
                        <Col md={6}>
                          <Form.Group>
                            <Form.Label>Mail Template ID for Sent Certificate</Form.Label>
                            <Form.Control
                              type="text"
                              placeholder="eg., TVI_DREAM_VACATION_CERTIFICATE"
                              name="mailTemplateIdForSentCertificate"
                              value={certi.mailTemplateIdForSentCertificate || ''}
                              onChange={handleCertiChange}
                            />
                          </Form.Group>
                        </Col>
                        <Col md={6}>
                          <Form.Group>
                            <Form.Label>Mail Template ID for Redeem Certificate</Form.Label>
                            <Form.Control
                              type="text"
                              placeholder="eg., TVI_DREAM_VACATION_REDEEM"
                              name="mailTemplateIdForRedeemCertificate"
                              value={certi.mailTemplateIdForRedeemCertificate || ''}
                              onChange={handleCertiChange}
                            />
                          </Form.Group>
                        </Col>
                      </Row>
                    ) : (
                      <>
                        <Row className="mb-3">
                          <Col md={6}>
                            <Form.Group>
                              <Form.Label>Redeem Description</Form.Label>
                              <CKEditor
                                editor={ClassicEditor}
                                data={certi.reddemDescription || ''}
                                onChange={(event, editor) => {
                                  handleCertiChange({ target: { name: 'reddemDescription', value: editor.getData() } });
                                }}
                              />
                            </Form.Group>
                          </Col>
                          <Col md={6}>
                            <Form.Group>
                              <Form.Label>Certificate Description</Form.Label>
                              <CKEditor
                                editor={ClassicEditor}
                                data={certi.certificateDesc || ''}
                                onChange={(event, editor) => {
                                  handleCertiChange({ target: { name: 'certificateDesc', value: editor.getData() } });
                                }}
                              />
                            </Form.Group>
                          </Col>
                        </Row>
                        <Row className="mb-3">
                          <Col md={6}>
                            <Form.Group>
                              <Form.Label>Certificate Fine Print</Form.Label>
                              <CKEditor
                                editor={ClassicEditor}
                                data={certi.certificateFinePrint || ''}
                                onChange={(event, editor) => {
                                  handleCertiChange({ target: { name: 'certificateFinePrint', value: editor.getData() } });
                                }}
                              />
                            </Form.Group>
                          </Col>
                          <Col md={6}>
                            <Form.Group>
                              <Form.Label>Short Description</Form.Label>
                              <CKEditor
                                editor={ClassicEditor}
                                data={certi.shortDescription || ''}
                                onChange={(event, editor) => {
                                  handleCertiChange({ target: { name: 'shortDescription', value: editor.getData() } });
                                }}
                              />
                            </Form.Group>
                          </Col>
                        </Row>
                      </>
                    )}
                  </div>
                )}

                <Button type="submit" variant="primary">Submit</Button>
              </>
            )}
          </Form>
        </div>
      </div>
    </LoadingOverlay>
    //     </div>
    // </div>
  );
};

export default CertificateAdd;

